import React from 'react';
import { Grid, Button, Divider } from '@mui/material';
import { Construction, CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';
import { BoolField } from '../../CommonComponents/Form';
import { SectionDivider } from '../../CommonComponents';
import METADATA_TYPES from '../../../types/MetadataType';
import { hasStandardProperty, changeStandardProperty } from '../../../utils/metadata';

interface EquipmentBlockProps {
    entity: any;
    onChange: (e: any) => void;
    settables: string[];
}

const EquipmentBlock = ({
    entity,
    onChange,
    settables = []
}: EquipmentBlockProps) => {
    const [selected, setSelected] = React.useState<'all' | 'some' | 'none'>('some');

    React.useEffect(() => {
        if (settables.every((equip) => entity.equipment?.includes(equip))) {
            setSelected('all');
        } else if ((entity.equipment?.length ?? 0) === 0) {
            setSelected('none');
        } else {
            setSelected('some');
        }
    }, [entity.equipment, settables]);

    const selectAll = () => {
        const currentEq = entity.equipment || [];
        const newEq = Array.from(new Set([...currentEq, ...settables]));
        onChange({ ...entity, equipment: newEq });
    };

    const selectNone = () => {
        const currentEq = entity.equipment || [];
        const newEq = currentEq.filter((eq: string) => !settables.includes(eq));
        onChange({ ...entity, equipment: newEq });
    };

    return (
        <Grid item lg={12} xl={6}>
            <SectionDivider
                label={`Utrustning (${entity.equipment?.length || 0})`}
                icon={<Construction fontSize="small" />}
                marginTop={2}
                marginBottom={0}
            />
            <Grid container spacing={1} sx={{ mb: 1 }}>
                <Grid item>
                    <Button
                        size="small"
                        variant="text"
                        onClick={() => selectAll()}
                        startIcon={selected === 'all' ? <CheckBox /> : <CheckBoxOutlineBlank />}
                    >
                        Alla
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        size="small"
                        variant="text"
                        onClick={() => selectNone()}
                        startIcon={selected === 'none' ? <CheckBox /> : <CheckBoxOutlineBlank />}
                        sx={{ fontWeight: 300 }}
                    >
                        Inga
                    </Button>
                </Grid>
            </Grid>
            <Divider sx={{ mb: 2, width: '160px' }} />
            <Grid container spacing={1}>
                {settables.map((eq: string) => (
                    <Grid item xs={4} key={eq}>
                        <BoolField
                            name={eq}
                            label={eq}
                            value={hasStandardProperty({ array: entity.equipment, value: eq })}
                            onChange={() => changeStandardProperty({
                                key: METADATA_TYPES.EQUIPMENT,
                                array: entity.equipment,
                                value: eq,
                                entity,
                                onChange
                            })}
                        />
                    </Grid>
                ))}
            </Grid>
        </Grid>
    );
};

export default React.memo(EquipmentBlock);
